import {Injectable, InjectionToken, Injector} from '@angular/core';
import {SocketIO, SocketIOOptions} from './serverConnection/adapters/SocketIO/SocketIO';
import {Local} from './serverConnection/adapters/Local/Local';
// import {isOffline} from "../../configs/view_only";

export let appInjector: Injector;

export const SERVER_CONNECTION_TOKEN = new InjectionToken<ServerConnectionInterface>('Server Connection Implementation');
let ServerConnectionProvider;
if (window.hasOwnProperty('SOCKETIO_HOST')) {
  const ServerConnectionInstance = new SocketIO({
    host: window['SOCKETIO_HOST'],
    port: window['SOCKETIO_PORT'],
    sid: window['SOCKET_SID'],
    eventId: window['EVENT_ID'],
    debug: true
  } as SocketIOOptions);

  ServerConnectionProvider = {
    provide: SERVER_CONNECTION_TOKEN,
    useValue: ServerConnectionInstance
  };
} else {
  // const ServerConnectionInstance = new SocketIO({
  //   host: window['SOCKETIO_HOST'],
  //   port: window['SOCKETIO_PORT'],
  //   sid: window['SOCKET_SID'],
  //   eventId: window['EVENT_ID'],
  //   offline: true,
  //   debug: true
  // } as SocketIOOptions);

  // ServerConnectionProvider = {
  //   provide: SERVER_CONNECTION_TOKEN,
  //   useValue: ServerConnectionInstance
  // };

  ServerConnectionProvider = {
    provide: SERVER_CONNECTION_TOKEN,
    useValue: new Local()
  };
}


// @ts-ignore
export let dependencyContainer = Injector.create({
  providers: [
    ServerConnectionProvider
  ]
});

@Injectable({
  providedIn: 'root'
})
export class AppInjector {
    constructor(private injector: Injector) {
      appInjector = this.injector;
    }
}
